import { NgModule } from "@angular/core";
import { AppointmentEventsService } from "src/app/events/appointment-events.service";
import { EventsService } from "src/app/events/events.service";
import { NotifyAppointmentFunctionModule } from "src/app/modules/bootstrap/pms-ui/functions/appointment/notify-appointment/notify-appointment-function.module";

@NgModule({
  imports: [NotifyAppointmentFunctionModule],
  declarations: [],
  exports: [],
  providers: [AppointmentEventsService, EventsService]
})
export class EventsModule {}
